// HealthCampForm.jsx
import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaCheckCircle, FaEnvelope, FaHeartbeat, FaUserMd } from "react-icons/fa";
import axios from "axios";
import "./Form.css";
import "./SewingMachineForm.css";
import BASE_URL from "../constant";

const HealthCampForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    age: "",
    idCardNumber: "",      // Ayushman Card / Aadhar Card number
    idCardType: "aadhar",  // aadhar / ayushman
    parentSpouseName: "",
    phone: "",
    address: "",
    healthIssue: ""
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.age || formData.age < 1 || formData.age > 120) newErrors.age = "Valid age is required (1-120)";
    if (!formData.idCardNumber.trim()) {
      newErrors.idCardNumber = "ID card number is required";
    } else if (formData.idCardType === "aadhar" && !/^\d{12}$/.test(formData.idCardNumber)) {
      newErrors.idCardNumber = "Valid 12-digit Aadhar number is required";
    }
    if (!formData.phone.trim() || !/^\d{10}$/.test(formData.phone)) newErrors.phone = "Valid 10-digit phone number is required";
    if (!formData.address.trim()) newErrors.address = "Address is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

      const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setLoading(true);

        try {
          const response = await axios.post(
            `${BASE_URL}/api/v1/mail/health-camp-form`,
            formData
          );

          if (response.data.success) {
            setSuccess(true);

            setFormData({
              name: "",
              age: "",
              idCardNumber: "",
              idCardType: "aadhar",
              parentSpouseName: "",
              phone: "",
              address: "",
              healthIssue: ""
            });

            setTimeout(() => setSuccess(false), 5000);
          }
        } catch (error) {
          console.error("Submission error:", error);
          alert("Server error. Please try again.");
        } finally {
          setLoading(false);
        }
      };

  return (
    <div className="health-camp-page">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} md={10} sm={12}>
            <div className="form-container health-camp-form mt-4">
              <div className="form-header">
                {/* Trust Registration Info */}
                <div className="trust-info" style={{ textAlign: "center", marginBottom: "20px", paddingBottom: "15px", borderBottom: "1px solid #e0e0e0" }}>
                  <h3 style={{ fontSize: "1.1rem", fontWeight: "bold", color: "#2e7d32", marginBottom: "5px" }}>
                    LATE SURESH SINGH FOUNDATION® TRUST
                  </h3>
                  <p style={{ fontSize: "0.75rem", color: "#666", marginBottom: "5px" }}>
                    (Registered under Indian Trust Act.)
                  </p>
                  <p style={{ fontSize: "0.7rem", color: "#888", marginBottom: "0" }}>
                    Trust Regd.No :- 375/22 | 80G, 12A, Darpan Niti Aayog, Aatma Nirbhar Bharat, CSR-1
                  </p>
                </div>

                {/* Patron and Founder */}
                <div className="patron-founder" style={{ display: "flex", justifyContent: "space-between", marginBottom: "25px", gap: "20px" }}>
                  <div style={{ textAlign: "center", flex: 1 }}>
                    <div style={{ fontWeight: "bold", fontSize: "1rem", color: "#1b5e20" }}>Shri Shyam Nandan Singh</div>
                    <div style={{ fontSize: "0.8rem", color: "#666", fontStyle: "italic" }}>(Patron)</div>
                  </div>
                  <div style={{ textAlign: "center", flex: 1 }}>
                    <div style={{ fontWeight: "bold", fontSize: "1rem", color: "#1b5e20" }}>Kshitij Ranjan 'Suresh'</div>
                    <div style={{ fontSize: "0.8rem", color: "#666", fontStyle: "italic" }}>(Founder Chairman)</div>
                  </div>
                </div>

                <div className="form-badge">
                  <FaHeartbeat className="form-badge-icon" />
                  <span>स्वास्थ्य सेवा पहल</span>
                </div>
                <h1 className="form-title">
                  स्वस्थ समाज की परिकल्पना हेतु <span className="highlight">स्वास्थ्य जांच शिविर का आयोजन</span>
                </h1>
              </div>
              {/* Success Message */}
              {success && (
                <div className="success-message">
                  <FaCheckCircle className="success-icon" />
                  <div>
                    <strong>धन्यवाद!</strong>
                    <p style={{ margin: 0, fontSize: "0.85rem" }}>आपका पंजीकरण सफलतापूर्वक हो गया है। शिविर की तिथि आपको सूचित कर दी जाएगी।</p>
                  </div>
                </div>
              )}

              {/* Form */}
              <form onSubmit={handleSubmit}>
                {/* Name */}
                <div className="form-group">
                  <label className="form-label">
                    नाम <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    className={`form-control ${errors.name ? 'error' : ''}`}
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="अपना पूरा नाम लिखें"
                  />
                  {errors.name && <span className="error-message">{errors.name}</span>}
                </div>

                <div className="form-row">
                  {/* Age */}
                  <div className="form-group">
                    <label className="form-label">
                      आयु <span className="required">*</span>
                    </label>
                    <input
                      type="number"
                      name="age"
                      className={`form-control ${errors.age ? 'error' : ''}`}
                      value={formData.age}
                      onChange={handleChange}
                      placeholder="आयु (वर्षों में)"
                    />
                    {errors.age && <span className="error-message">{errors.age}</span>}
                  </div>

                  {/* ID Card Number with Type Selection */}
                  <div className="form-group">
                    <label className="form-label">
                      कार्ड संख्या <span className="required">*</span>
                    </label>
                    <div className="id-card-group">
                      <select
                        name="idCardType"
                        className="id-card-type-select"
                        value={formData.idCardType}
                        onChange={handleChange}
                      >
                        <option value="aadhar">आधार कार्ड</option>
                        <option value="ayushman">आयुष्मान कार्ड</option>
                      </select>
                      <input
                        type="text"
                        name="idCardNumber"
                        className={`form-control id-card-number-input ${errors.idCardNumber ? 'error' : ''}`}
                        value={formData.idCardNumber}
                        onChange={handleChange}
                        placeholder={formData.idCardType === "aadhar" ? "12 अंकों का आधार नंबर" : "आयुष्मान कार्ड नंबर"}
                        maxLength={formData.idCardType === "aadhar" ? "12" : "20"}
                      />
                    </div>
                    {errors.idCardNumber && <span className="error-message">{errors.idCardNumber}</span>}
                  </div>
                </div>

                {/* Parent/Spouse Name */}
                <div className="form-group">
                  <label className="form-label">
                    माता/पिता/पति का नाम
                  </label>
                  <input
                    type="text"
                    name="parentSpouseName"
                    className="form-control"
                    value={formData.parentSpouseName}
                    onChange={handleChange}
                    placeholder="माता, पिता या पति का नाम"
                  />
                </div>

                {/* Phone Number */}
                <div className="form-group">
                  <label className="form-label">
                    फोन नंबर <span className="required">*</span>
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    className={`form-control ${errors.phone ? 'error' : ''}`}
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="10 अंकों का मोबाइल नंबर"
                    maxLength="10"
                  />
                  {errors.phone && <span className="error-message">{errors.phone}</span>}
                </div>

                {/* Address */}
                <div className="form-group">
                  <label className="form-label">
                    पता <span className="required">*</span>
                  </label>
                  <textarea
                    name="address"
                    className={`form-control ${errors.address ? 'error' : ''}`}
                    value={formData.address}
                    onChange={handleChange}
                    placeholder="गाँव, पोस्ट, थाना, जिला सहित पूरा पता"
                    rows="3"
                  />
                  {errors.address && <span className="error-message">{errors.address}</span>}
                </div>

                {/* Health Issue */}
                <div className="form-group">
                  <label className="form-label">
                    शारीरिक समस्या
                  </label>
                  <textarea
                    name="healthIssue"
                    className="form-control"
                    value={formData.healthIssue}
                    onChange={handleChange}
                    placeholder="कृपया अपनी शारीरिक समस्या का विवरण लिखें (यदि कोई हो)"
                    rows="3"
                  />
                </div>

                <button type="submit" className="submit-btn" disabled={loading}>
                  {loading ? (
                    <>
                      <div className="spinner"></div>
                      जमा कर रहे हैं...
                    </>
                  ) : (
                    <>
                      <FaEnvelope className="btn-icon" />
                      पंजीकरण करें
                    </>
                  )}
                </button>
              </form>

              {/* Footer Info */}
              <div className="form-footer">
                <p>
                  <strong>आयोजक:</strong> स्व० सुरेश सिंह फाउंडेशन® ट्रस्ट<br />
                  (ग्राम लई, बिहटा, पटना)
                </p>

              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HealthCampForm;